var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"alert alert-warning",attrs:{"role":"alert"}},[_vm._v("\n        3/31(月)21:00以降をもって外航貨物保険の新規付保は受付停止となりました。\n    ")]),_vm._v(" "),_c('GridPage',{ref:"gridPage",attrs:{"form-default":{
            items: [],
            status: 'draft',
        },"filters-default":{
            status: '',
            shipping_tracking_confirmed_at: '',
            sort: '-shipping_tracking_confirmed_at',
        },"filter-items":[
            {
                vModel: 'status',
                title: '状態',
                options: [
                    { text: '全て', value: '' },
                    { text: '登録済', value: 'draft' },
                    { text: '有効確認済', value: 'activated' },
                    { text: '無効', value: 'error_timeout,error_invalid' } ],
            },
            {
                vModel: 'shipping_tracking_confirmed_at',
                title: '追跡有効確認日時',
                type: 'date-range',
                options: {
                    force_range: false,
                },
            },
            {
                vModel: 'sort',
                title: '順番',
                options: [
                    { text: '▲ 追跡有効確認日時', value: 'shipping_tracking_confirmed_at', },
                    { text: '▼ 追跡有効確認日時', value: '-shipping_tracking_confirmed_at' } ],
            } ],"filters-q-placeholder":"氏名、会社名、メール、電話、Tuskey保険番号","form-modal-id":"insurance","search-action":"insurance/index","filter-search-results":_vm.filterSearchResults,"row-class":"flex-nowrap mx-0 my--2","hide-download":false,"hide-table":true,"hide-add":true,"open-detail-after-saving":false,"item-id":"id"},on:{"after-save":_vm.afterSave,"after-destroy":_vm.afterDestroy},scopedSlots:_vm._u([{key:"form",fn:function(ref){
        var form = ref.form;
        var init = ref.init;
return [_c('Insurance',{attrs:{"model":form,"init":init},on:{"save":_vm.$refs.gridPage.save,"destroy":_vm.$refs.gridPage.destroy}})]}},{key:"search-append",fn:function(ref){
        var form = ref.form;
        var init = ref.init;
return [(_vm.auth_level >= '300')?_c('b-input-group-append',[_c('b-button',{attrs:{"type":"button"},on:{"click":_vm.downloadInvoices}},[_c('font-awesome-icon',{attrs:{"icon":"file-invoice-dollar"}})],1)],1):_vm._e()]}},{key:"before-filter",fn:function(){return undefined},proxy:true},{key:"after-table",fn:function(){return [_c('InsuranceTable',{ref:"table",attrs:{"mode":"read"},on:{"on-detail":_vm.onDetail}})]},proxy:true}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }